





























































































































































































































































































import Vue from "vue";
import i18n, { hasTranslation } from "../../../lang/i18n";
import Accordion from "../../shared/Accordion.vue";
import { Component, Prop } from "vue-property-decorator";
import { ProformaDetailsManagementDef } from "../../../model/component.model";
import { CurrencyType, MeasurementUnitsDTO } from "../../../model/data.model";
import { minLength, required, requiredIf } from "vuelidate/lib/validators";
import { isGermany, isUk } from "@/services/Helpers";
import numbro from "numbro";

@Component({
  components: {
    MbeAccordion: Accordion
  },
  validations() {
    const self = this as any;
    return {
      itemLine: {
        measureOfMeasurement: {
          required: requiredIf(() => {
            return !self.mbeMeasureUnitCode;
          })
        },
        description: {
          required
        },
        hsCodeUKCheck: {
          required: requiredIf(() => {
            return self.isParcelForceUk;
          }),
          minLength: () => self.minLengthHsCode
        }
      }
    };
  }
})
export default class ProformaModalLine extends Vue {
  @Prop() itemLine: ProformaDetailsManagementDef;
  @Prop() currencyLine: CurrencyType;
  @Prop() musLine: MeasurementUnitsDTO[];
  @Prop() validations: any;
  @Prop() lineIndex: number;
  @Prop() disabled: boolean;
  @Prop({ default: false }) weightVisible: boolean;
  @Prop() countries: any[];
  @Prop() parcels: any[];
  @Prop() invalidItem: boolean;
  @Prop() shipment: any;
  countriesFiltered: any[] = [];
  rerenderKey = 0;
  showErrorByHsCode = false;

  get minLengthHsCode() {
    if (this.uk) {
      return minLength(10);
    }
    return minLength(8);
  }

  get isParcelForceUk(): boolean {
    return isUk() && this.shipment.courierId === 29;
  }

  created() {
    this.shownItemLineSingleValue = this.itemLine.itemsSingleValue
      ? this.itemLine.itemsSingleValue
      : "0.01";
    this.shownItemLineWeight = this.itemLine.weight
      ? this.itemLine.weight
      : "0.0";

    this.countriesFiltered = JSON.parse(JSON.stringify(this.countries));
  }

  get showTaxDutyLogic() {
    return (
      this.$store.getters["shipment/enableTaxDutySection"] &&
      this.isTaxDutyEnabled
    );
  }

  isUKHsCodeValid(item: any) {
    if (!this.uk) return true; // do the check only for non uk tenant
    if (!item.hsCode) return false;
    return String(item.hsCode).length == 6 || String(item.hsCode).length == 8;
  }

  get isTaxDutyEnabled() {
    return this.$store.getters["customer/isTaxDutyEnabled"] as boolean;
  }

  deleteLine() {
    if (this.disabled) {
      return;
    }
    this.$emit("delete-event", {
      line: this.itemLine,
      lineIndex: this.lineIndex
    });
  }

  onItemsNumberChange() {
    if (this.disabled) {
      return;
    }
    this.$emit("itemsNumberChange-event", {
      line: this.itemLine,
      lineIndex: this.lineIndex
    });
  }

  onItemsSingleValueFocusOut(e) {
    if (this.disabled) {
      return;
    }

    this.shownItemLineSingleValue = e.target.value;
    this.rerender();

    this.$emit("itemsSingleValueChange-event", {
      line: this.itemLine,
      lineIndex: this.lineIndex
    });
  }

  get isGermanyAndCourierDPD() {
    return isGermany() && this.shipment.courierId == 13;
  }

  get isGermanyAndCourierDHL() {
    return isGermany() && this.shipment.courierId === 4;
  }

  rerender() {
    this.rerenderKey += 1;
  }

  onItemLineWeightFocusOut(e) {
    this.shownItemLineWeight = e.target.value;
    this.rerender();
  }

  resetCountriesFiltered() {
    setTimeout(() => {
      this.countriesFiltered = this.countries;
    }, 100);
  }

  validateHsCodeGermanyDPDCourier(hsCode: any) {
    if (!hsCode) hsCode = "";
    if (hsCode.length >= 8 && hsCode.length <= 10) {
      return !isNaN(hsCode);
    }
    return false;
  }

  validateHsCodeForDHL(hsCode: any) {
    if (hsCode && hsCode.length && hsCode.length <= 18) {
      return !isNaN(hsCode);
    }
    return false;
  }

  measurementUnitChanged(event) {
    this.shownUnitOfMeasurement = event;
    this.itemLine.mbeMeasureUnitCode = event.code;
  }

  get measureOptions() {
    return this.musLine
      .map((mut: MeasurementUnitsDTO) => {
        const label = hasTranslation(mut.weblateKey)
          ? i18n.t(mut.weblateKey)
          : mut.description;

        return {
          value: mut.description,
          label: label + " (" + mut.code + ")",
          code: mut.code
        };
      })
      .sort((a: any, b: any) => (a.label < b.label ? -1 : 1));
  }

  formatNumber(num: number, decimalPrecision = 2) {
    if (isUk()) {
      numbro.setLanguage("en-GB");
    } else {
      numbro.setLanguage("it-IT");
    }

    const formattedNum = numbro(num).format({
      thousandSeparated: true,
      mantissa: decimalPrecision
    });

    return formattedNum;
  }

  parseNumber(num: string, decimalPrecision = 2) {
    const defaultNumber = decimalPrecision === 2 ? 0.01 : 0.0;

    if (isUk()) {
      return isNaN(Number(`${num}`.replace(",", "")))
        ? defaultNumber
        : Number(Number(`${num}`.replace(",", "")).toFixed(decimalPrecision));
    } else {
      return isNaN(Number(`${num}`.replace(",", ".")))
        ? defaultNumber
        : Number(Number(`${num}`.replace(",", ".")).toFixed(decimalPrecision));
    }
  }

  get shownItemLineSingleValue() {
    return this.formatNumber(this.itemLine.itemsSingleValue);
  }

  set shownItemLineSingleValue(value) {
    this.itemLine.itemsSingleValue = this.parseNumber(value);
  }

  get shownItemLineTotalValue() {
    return this.formatNumber(this.itemLine.itemsTotalValue);
  }

  set shownItemLineTotalValue(value) {
    this.itemLine.itemsTotalValue = this.parseNumber(value);
  }

  get shownItemLineWeight() {
    return this.formatNumber(this.itemLine.weight, 1);
  }

  set shownItemLineWeight(value) {
    this.itemLine.weight = this.parseNumber(value, 1);
  }

  get shownUnitOfMeasurement() {
    const matchingUnitOfMeasurement = this.measureOptions.find(
      measure => measure.value === this.itemLine.measureOfMeasurement
    );

    return matchingUnitOfMeasurement ? matchingUnitOfMeasurement.label : "";
  }

  set shownUnitOfMeasurement(value: any) {
    this.itemLine.measureOfMeasurement = value.value;
  }

  hasWeightError(weight: any) {
    return weight <= 0;
  }

  maxLenghtDescription(item: any) {
    return (
      item.description.length > 102 &&
      !item.descriptiveRow &&
      this.shipment &&
      this.shipment.courierId == 1
    );
  }

  get uk() {
    return isUk();
  }
}
